import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-international-phone/style.css";
import { OrganizationProvider } from "./utils/OrganizationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <OrganizationProvider>
    <BrowserRouter>
      <CssBaseline />
      <ToastContainer autoClose={false} />
      <App />
    </BrowserRouter>
  // </OrganizationProvider>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.log("Service worker registration failed:", err));
  });
}
